<template>
    <div class="edit-pages-home-form">
        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <div class="content">
                <b-form-group label="Título principal" label-for="title">
                    <b-form-textarea
                        id="title"
                        name="title"
                        v-model="form.title"
                        placeholder="Descreva aqui."
                        rows="6"
                    ></b-form-textarea>
                </b-form-group>

                <b-form-group label="Subtítulo" label-for="subtitle">
                    <b-form-textarea
                        id="subtitle"
                        name="subtitle"
                        v-model="form.subtitle"
                        placeholder="Descreva aqui."
                        rows="6"
                    ></b-form-textarea>
                </b-form-group>

                <FormFilePP
                    :label="'Banner principal'"
                    :text1="textFile1"
                    :text2="textFile2"
                    :accept="'image/jpeg, image/jpg, image/png'"
                    :singleFile="true"
                    :previewImg="true"
                />
            </div>

            <div class="footer-buttons">
                <hr class="line" />

                <b-button type="submit" class="radius-6 submit" :variant="'primary'">
                    Alterar
                </b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
import FormFilePP from '@/ui/form-file-pp/FormFilePP'

export default {
    name: 'EditPagesHomeForm',
    components: { FormFilePP },
    data() {
        return {
            form: {
                title: null,
                subtitle: null
            },
            textFile1: 'Tamanho de upload de imagem para 2 Mb',
            textFile2: 'Arquivos suportados: .png. e, .jpg'
        }
    },
    methods: {
        onSubmit() {
            // console.log('submit >>>', this.form)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/private/dashboard-admin-grid-page/edit-pages-admin/edit-pages-home-form/EditPagesHomeForm.vue